/**
 * @file     shared.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings shared across multiple pages.
 */
export const shared = {} as const;
